// src/api/documents/endpoints.ts
export const DOCUMENTS_ENDPOINTS = {
  BASE: "/v1/documents",
  DETAIL: (id: string) => `/v1/documents/${id}`,
  CHAPTER: (id: string) => `/v1/documents/${id}/chapter`,
  LATEST_VERSION: (documentId: string) => `/v1/documents/${documentId}/latest-version`,
  /** Markdown (défaut) ou manifeste de la dernière version d'un chapitre importé. */
  CHAPTER_SOURCE: (documentId: string) => `/v1/documents/${documentId}/chapter-source`,
  /** Relecture humaine : état, points à vérifier, historique (GET) ; décision (POST). */
  REVIEW: (documentId: string) => `/v1/documents/${documentId}/review`,
  /** Ouverture du cours aux élèves (son interrupteur propre). */
  ACTIVATION: (documentId: string) => `/v1/documents/${documentId}/activation`,
} as const;
